'use strict';

angular.module('AcaApp').factory('ProfileService',
  ['$rootScope',
    '$window',
    'ManagedUserInformationService',
    function($rootScope, $window, ManagedUserInformationService){
      return{
        typeOfUser: function(){
          this.userIsAdmin();
          this.userIsEditor();
          this.userIsReadOnly();
          this.userIsSovosProfile();
          this.userIsManagedServices();
        },
        userIsReadOnly: function(){
          $rootScope.isReadOnly = ($window.sessionStorage.profile === 'CNV_ACARO');
        },
        userIsAdmin: function(){
          $rootScope.isAdmin = ($window.sessionStorage.profile === 'CNV_ACAADMIN');
        },
        userIsEditor: function(){
          $rootScope.isEditor = ($window.sessionStorage.profile === 'CNV_ACA');
        },
        userIsSovosProfile: function(){
          $rootScope.isSovosProfile = ($window.sessionStorage.profile === 'CNV_ACASOVOS');
        },
        userIsManagedServices: function(){
          $rootScope.isManagedServices = ManagedUserInformationService.isManagedServicesAndNotSovosProfile();
        }
      };
    }
  ]);